import { useNavigate } from 'react-router-dom';
import { useNewProjectUrl } from 'domain/shared/newProject';
import { IconButton, Tooltip } from '@mui/material';
import PeopleIcon from '@mui/icons-material/PeopleOutlined';
import ProjectsIcon from '@mui/icons-material/DashboardOutlined';
import { useStaffingProjectUrl } from './route/staffingProject';

interface SwitchToProjectViewButtonProps {
  projectId: string;
  isStaffingView: boolean;
}

const SwitchToProjectViewButton = ({ projectId, isStaffingView }: SwitchToProjectViewButtonProps) => {
  const navigate = useNavigate();
  const { getSingleEntityUrl } = useNewProjectUrl();
  const { getStaffingProjectUrl } = useStaffingProjectUrl();

  if (isStaffingView) {
    return (
      <Tooltip title="Go to staffing view">
        <IconButton color="primary" onClick={() => navigate(getStaffingProjectUrl(projectId))}>
          <PeopleIcon />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Tooltip title="Go to project view">
      <IconButton color="primary" sx={{ mr: 0 }} onClick={() => navigate(getSingleEntityUrl(projectId))}>
        <ProjectsIcon />
      </IconButton>
    </Tooltip>
  );
};

export default SwitchToProjectViewButton;
